import React from "react";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useHistory } from "react-router-dom";

const SomethingWrongSignUp = () => {
    const history = useHistory();
  return (
    <div
      style={{
        width: "100%",
        height: window.innerHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ErrorOutlineIcon
        style={{ color: "rgb(37, 97, 153)", fontSize: "120px" }}
      />
      <div
        style={{
          fontSize: "30px",
          fontWeight: 800,
          color: "grey",
          marginTop: "20px",
        }}
      >
        Sign Up Error
      </div>
      <div
        style={{
          fontSize: "12px",
          color: "grey",
          width: "60%",
          textAlign: "center",
        }}
      >
        It seems you have reached a road bump on your sign up process, take note
        that due to ensuring the security of each and every user, the
        verfication link is only usable for the first 10 minutes. Please retry
        your sign up process.
      </div>
      <div
            className="menu_button"
            onClick={() => {
              history.push("/auth/signin");
              window.scrollTo(0, 0);
            }}
        style={{
          fontSize: "14px",
          fontWeight: "700",
          color: "white",
          border: "2px solid #256199",
          background: "#256199",
          padding: "5px 40px",
          borderRadius: "15px",
          marginTop: "20px",
        }}
      >
        Back to login
      </div>
    </div>
  );
};

export default SomethingWrongSignUp;
